import { http } from "services/http";

import type {
  TicketCloseResponse,
  TicketDetails,
  TicketIdRequest,
  TicketMessageAddRequest,
  TicketsListRequest,
  TicketsListResponse,
} from "models/tickets.model";

export const ticketsApi = {
  getTickets: (data?: TicketsListRequest) =>
    http.quiet().post<TicketsListResponse>("/api/tickets", data ? { ...data } : null),
  getTicketData: (data: TicketIdRequest) =>
    http.quiet().post<TicketDetails>("/api/tickets/edit", { ...data }),
  addMessage: (data: TicketMessageAddRequest) =>
    http.quiet().post("/api/tickets/message/add", { ...data }),
  closeTicket: (id: string) => http.quiet().post<TicketCloseResponse>("/api/tickets/close", { id }),
};
